import { SET_PREDICTOR, SET_MONEYPLAN, SET_FIRSTTIME, SET_GAMEMODE, SET_GAMEROOM } from '../actions'
import dotProp from 'dot-prop-immutable';

const initialState = {
    predictor: 'basic',
    moneyplan: 'plain',
    is_firsttime: true,
    game_mode: 'manual',
    game_room: '',
}

export default (state, action) => {
    let state_ = state || initialState;
    switch (action.type) {
        case SET_PREDICTOR:
            state_ = dotProp.set(state_, `is_firsttime`, false);
            state_ = dotProp.set(state_, `predictor`, action.data);
            return state_;
        case SET_MONEYPLAN:
            state_ = dotProp.set(state_, `is_firsttime`, false);
            state_ = dotProp.set(state_, `moneyplan`, action.data);
            return state_
        case SET_FIRSTTIME:
            state_ = dotProp.set(state_, `is_firsttime`, false);
            return state_
        case SET_GAMEMODE:
            state_ = dotProp.set(state_, `game_mode`, action.data);
            return state_
        case SET_GAMEROOM:
            state_ = dotProp.set(state_, `game_room`, action.data);
            return state_
    
    }
    return state || initialState
}
